<template>
  <div
    v-if="newses.length > 0"
    class="newses"
    :class="{ visible: isNewsVisible }"
  >
    <div class="news-slider" ref="newsSlider">
      <article v-for="(news, index) in newses" :key="news.id" class="news">
        <div class="news__img-wrap">
          <div
            class="news__img"
            :style="{
              backgroundImage: 'url(' + getImage(news.imageBig) + ')',
            }"
          ></div>
        </div>
        <div class="news__content">
          <div class="news__line"></div>
          <div class="blur"></div>
          <div class="animation-container">
            <span class="-decor">news / {{ formatDate(news.date) }}</span>
          </div>
          <div class="animation-container">
            <h2 class="news__title">
              {{ news.title | truncate(30) }}
            </h2>
          </div>
          <div class="animation-container">
            <div
              class="news__abstract"
              :inner-html.prop="news.abstract | truncate(90)"
            ></div>
          </div>
          <div class="animation-container">
            <a
              v-if="!news.launcher || news.link"
              :href="newsLink(news)"
              target="_blank"
              class="btn"
              :id="`pad-news-button-${index + 1}`"
              pad-a="click"
              :pad-down="`go:#pad-news-${index + 1}`"
              pad-up="go:#pad-home"
              pad-right="news:next"
              pad-left="news:prev"
            >
              {{ $t("read_more") }}
            </a>
          </div>
        </div>
      </article>
    </div>
    <ol class="flickity-page-dots">
      <li
        class="dot"
        :class="{ 'is-selected': activeSlide === 1 }"
        id="pad-news-1"
        pad-right="go:#pad-news-2"
        pad-left="go:#pad-play,#pad-get-game"
        pad-down="go:#pad-merch-1"
        :pad-up="`go:#pad-news-button-${activeSlide}`"
        pad-a="click"
        tabindex="1"
        @click="changeSlide(1)"
      ></li>
      <li
        class="dot"
        :class="{ 'is-selected': activeSlide === 2 }"
        id="pad-news-2"
        pad-right="go:#pad-news-3"
        pad-left="go:#pad-news-1"
        pad-down="go:#pad-merch-1"
        :pad-up="`go:#pad-news-button-${activeSlide}`"
        pad-a="click"
        tabindex="1"
        @click="changeSlide(2)"
      ></li>
      <li
        class="dot"
        :class="{ 'is-selected': activeSlide === 3 }"
        id="pad-news-3"
        pad-left="go:#pad-news-2"
        pad-down="go:#pad-merch-1"
        :pad-up="`go:#pad-news-button-${activeSlide}`"
        pad-a="click"
        tabindex="1"
        @click="changeSlide(3)"
      ></li>
    </ol>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import axios from "axios";
import Flickity from "flickity";

let flkty;

export default {
  name: "News",
  props: {
    cacheVersion: {
      type: String,
    },
    game: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sliderOptions: {
        prevNextButtons: false,
        wrapAround: true,
        align: "left",
        pageDots: false,
        resize: true,
        setGallerySize: false,
        on: {
          ready: () => {
            this.isNewsVisible = true;
          },
        },
      },
      newses: [],
      isNewsVisible: false,
      activeSlide: 1,
    };
  },

  methods: {
    formatDate(date) {
      const d = parseISO(date);
      const datestring = format(d, "PP");
      return datestring;
    },

    newsLink(news) {
      return news.link
        ? news.link
        : `https://baldursgate3.game/news/${news.slug}`;
    },

    getImage(image) {
      return image
        ? `${process.env.VUE_APP_API_HOST}${image.url}`
        : "require(./assets/img/jpg/main.png)";
    },

    initSlider() {
      // eslint-disable-next-line
      flkty = new Flickity(this.$refs.newsSlider, this.sliderOptions);
      document.newsSlider = flkty;

      flkty.on("change", () => {
        this.activeSlide = flkty.selectedIndex + 1;
      });

      document.newsSlider.on("change", function(index) {
        if (this.isPad) {
          document.pad.focus(`#pad-news-button-${index + 1}`);
          this.isPad = false;
        }
      });

      // flkty.on("staticClick", (event, pointer, cellElement, cellIndex) => {
      //   if (cellIndex != undefined) {
      //     flkty.selectCell(cellIndex);
      //     this.activeSlide = cellIndex + 1;
      //   }
      // });
    },

    changeSlide(index) {
      this.activeSlide = index;
      flkty.select(this.activeSlide - 1);
    },

    fetchNews() {
      const version = this.cacheVersion;
      const gameCode = this.game.toLowerCase();

      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/cache/news/news-launcher-${gameCode}.json${version}`,
          { withCredentials: false }
        )
        .then((res) => {
          this.newses = res.data;
          setTimeout(() => {
            this.initSlider();
          }, 100);
        });
    },
  },

  mounted() {
    this.fetchNews();
  },
};
</script>

<style lang="scss" scoped>
.newses {
  width: 35vw;
  height: 41vh;
  margin-bottom: 4vh;
}

.news-slider {
  height: 100%;
}

.news {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  &__img-wrap {
    height: 17vh;
    flex-shrink: 0;
    overflow: hidden;
  }

  &__img {
    width: 100%;
    height: 100%;
    background-color: $black;
    background-size: cover;
    background-position: center top;
    background-image: url("~@/assets/img/jpg/placeholder.jpg");
    transition: transform 0.3s ease;
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 1.2vw 3vw 2vw 3vw;
    position: relative;
    z-index: 1;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: $black;
      opacity: 0.4;
      z-index: -1;
    }

    .blur {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      backdrop-filter: blur(12px);
      filter: blur(1px);
      z-index: -1;
    }
  }

  &__line {
    position: absolute;
    top: calc(1.2vw + 25px);
    transform: translateY(calc(-100% - 1.2vw - 25px));
    left: 0;
    width: 2px;
    height: 35px;
    background: $yellow;
    animation: slide-in 500ms forwards;
    animation-delay: 2800ms;
  }

  .-decor {
    font-size: 10px;
    margin-bottom: 10px;
    transform: translateY(160%);
    animation: slide-in 500ms forwards;
    animation-delay: 1800ms;
  }

  &__title {
    color: $white;
    font-size: 18px;
    margin-bottom: 10px;
    transform: translateY(200%);
    animation: slide-in 500ms forwards;
    animation-delay: 1800ms;
  }

  &__abstract {
    font-size: 14px;
    color: $white-70;
    transform: translateY(200%);
    animation: slide-in 500ms forwards;
    animation-delay: 1900ms;
  }

  .btn {
    margin-top: 10px;
    transform: translateX(-100%);
    animation: slide-in-button 500ms forwards;
    animation-delay: 2300ms;
  }

  &:hover {
    .news__img {
      transform: scale(1.1);
    }
  }
}

@media screen and (max-height: 650px) {
  .news {
    &__abstract {
      display: none;
    }
  }
}

@media screen and (min-width: $screen-medium) {
  .newses {
    height: 48vh;
  }

  .news {
    .-decor {
      font-size: 12px;
    }

    &__title {
      font-size: 22px;
    }

    &__abstract {
      display: block;
    }
  }
}
</style>

<style lang="scss">
.newses {
  .flickity-page-dots {
    bottom: -15px;
  }
}
.news__abstract {
  p {
    margin: 0;
    font-size: 15px;
  }
}

@keyframes slide-in {
  100% {
    transform: translateY(0);
  }
}

@keyframes slide-in-button {
  100% {
    transform: translateX(0);
  }
}
</style>
